/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R2_LabelInputs */

const tr_iletisim_s7_r2_label = /** @type {(inputs: Iletisim_S7_R2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Mahkemeleri`)
};

const en_iletisim_s7_r2_label = /** @type {(inputs: Iletisim_S7_R2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Mahkemeleri (consumer courts)`)
};

const de_iletisim_s7_r2_label = /** @type {(inputs: Iletisim_S7_R2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Mahkemeleri (Verbrauchergerichte)`)
};

const ru_iletisim_s7_r2_label = /** @type {(inputs: Iletisim_S7_R2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Mahkemeleri (суды по потребительским спорам)`)
};

/**
* | output |
* | --- |
* | "Tüketici Mahkemeleri (consumer courts)" |
*
* @param {Iletisim_S7_R2_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r2_label = /** @type {((inputs?: Iletisim_S7_R2_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R2_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r2_label(inputs)
	if (locale === "de") return de_iletisim_s7_r2_label(inputs)
	if (locale === "ru") return ru_iletisim_s7_r2_label(inputs)
	return tr_iletisim_s7_r2_label(inputs)
});